import React, { useState } from 'react';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from './firebase';

const cor = '#B51013';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const [modo, setModo] = useState('login'); // 'login' | 'reset'
  const [resetMsg, setResetMsg] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErro('');
    const ERROS = {
      'auth/user-disabled': 'Conta desativada. Entre em contato com o RH.',
      'auth/too-many-requests': 'Muitas tentativas. Aguarde alguns minutos antes de tentar novamente.',
      'auth/user-not-found': 'E-mail não encontrado no sistema.',
      'auth/wrong-password': 'Senha incorreta.',
      'auth/invalid-credential': 'E-mail ou senha incorretos.',
      'auth/network-request-failed': 'Sem conexão. Verifique sua internet.',
    };
    try {
      await signInWithEmailAndPassword(auth, email, senha);
      navigate('/dashboard');
    } catch (e) {
      const msg = ERROS[e.code] || 'Erro ao entrar. Tente novamente.';
      setErro(msg);
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (!email) { setErro('Digite seu e-mail.'); return; }
    setLoading(true);
    setErro('');
    try {
      await sendPasswordResetEmail(auth, email);
      setResetMsg(`Link enviado para ${email}. Verifique sua caixa de entrada.`);
    } catch {
      setErro('E-mail não encontrado. Verifique o endereço digitado.');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif', padding: '16px' }}>
      <div style={{ background: '#fff', borderRadius: '12px', padding: '40px', width: '100%', maxWidth: '400px', boxShadow: '0 4px 24px rgba(0,0,0,0.10)' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img src="/logomarca.png" alt="Jatear" style={{ height: '72px', objectFit: 'contain', marginBottom: '16px' }} />
          <div style={{ fontSize: '13px', color: '#444' }}>
            {modo === 'login' ? 'Plataforma de Treinamentos' : 'Recuperar senha'}
          </div>
        </div>

        {/* Formulário de login */}
        {modo === 'login' && (
          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '6px' }}>E-mail</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" required
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
            </div>
            <div style={{ marginBottom: '8px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '6px' }}>Senha</label>
              <input type="password" value={senha} onChange={e => setSenha(e.target.value)} placeholder="••••••••" required
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
            </div>
            <div style={{ textAlign: 'right', marginBottom: '20px' }}>
              <span onClick={() => { setModo('reset'); setErro(''); setResetMsg(''); }} style={{ fontSize: '12px', color: cor, cursor: 'pointer', textDecoration: 'underline' }}>
                Esqueci minha senha
              </span>
            </div>
            {erro && <div style={{ background: '#FCEBEB', color: cor, padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' }}>{erro}</div>}
            <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px', background: loading ? '#ccc' : cor, color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
        )}

        {/* Formulário de reset */}
        {modo === 'reset' && (
          <form onSubmit={handleReset}>
            {!resetMsg ? (
              <>
                <div style={{ fontSize: '13px', color: '#666', marginBottom: '16px', lineHeight: '1.5' }}>
                  Informe seu e-mail cadastrado. Enviaremos um link para redefinir sua senha.
                </div>
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ fontSize: '12px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '6px' }}>E-mail</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" required
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
                </div>
                {erro && <div style={{ background: '#FCEBEB', color: cor, padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' }}>{erro}</div>}
                <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px', background: loading ? '#ccc' : cor, color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer', marginBottom: '12px' }}>
                  {loading ? 'Enviando...' : 'Enviar link de recuperação'}
                </button>
              </>
            ) : (
              <div style={{ background: '#E1F5EE', color: '#085041', padding: '14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px', lineHeight: '1.5' }}>
                ✅ {resetMsg}
              </div>
            )}
            <button type="button" onClick={() => { setModo('login'); setErro(''); setResetMsg(''); }} style={{ width: '100%', padding: '10px', background: 'none', border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '13px', color: '#666', cursor: 'pointer' }}>
              Voltar ao login
            </button>
          </form>
        )}

        <div style={{ textAlign: 'center', marginTop: '24px', fontSize: '11px', color: '#aaa' }}>www.jatear.com</div>
      </div>
    </div>
  );
}
